import { QuizCategory } from "src/data/models/quiz/QuizCategoryModel";
import { QuizQuestion } from "src/data/models/quiz/QuizQuestionModel";
import quizQuestions from "src/data/quiz-questions/AllQuizQuestions";

const QUESTION_NUMBER_PER_CATEGORY = process.env.NODE_ENV === 'production' ? 20 : 5;

// Generate quiz questions based on selected categories
function generateQuiz(selectedCategories: QuizCategory[]): QuizQuestion[] {
  const allQuestions = quizQuestions;

  // If "ALL" is selected, return a random set of 20 questions
  if (selectedCategories.includes(QuizCategory.ALL)) {
    return allQuestions.sort(() => Math.random() - 0.5).slice(0, QUESTION_NUMBER_PER_CATEGORY);
  }

  // Filter questions by selected categories
  const questionsByCategory = allQuestions.filter((question) =>
    selectedCategories.includes(question.category)
  );

  // Shuffle questions for randomness using Fisher-Yates shuffle
  const shuffledQuestions = [...questionsByCategory];
  for (let i = shuffledQuestions.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledQuestions[i], shuffledQuestions[j]] = [shuffledQuestions[j], shuffledQuestions[i]];
  }

  // Create a map to store questions by category, initializing with empty arrays
  const categoryQuestionMap: { [key in QuizCategory]: QuizQuestion[] } = {
    ALL: [],
    SER_VS_ESTAR: [],
    POR_VS_PARA: [],
    PRESENT: [],
    PAST_TENSE: [],
    FUTURE_TENSE: [],
    CONDITIONAL: [],
    SUBJUNCTIVE: [],
    PREPOSITIONS: [],
    IDIOMATIC_EXPRESSIONS: [],
    DISCOURSE_CONNECTORS: [],
    IMPERATIVE: [],
    PRONOUNS: [],
    VERBOS_REFLEXIVOS: [],
    VOZ_ACTIVA_PASIVA: [],
    PRONUNCIATION: [],
  };

  // Distribute questions into their respective categories
  shuffledQuestions.forEach((question) => {
    if (categoryQuestionMap[question.category]) {
      categoryQuestionMap[question.category].push(question);
    }
  });

  // List to store the final selected quiz questions
  const selectedQuizQuestions: QuizQuestion[] = [];

  // Ensure at least one question per selected category
  selectedCategories.forEach((category) => {
    const questionsForCategory = categoryQuestionMap[category];
    if (questionsForCategory && questionsForCategory.length > 0) {
      selectedQuizQuestions.push(
        questionsForCategory[Math.floor(Math.random() * questionsForCategory.length)]
      );
    }
  });

  // If fewer than 20 questions, randomly add more until reaching 20
  while (selectedQuizQuestions.length < QUESTION_NUMBER_PER_CATEGORY) {
    const remainingQuestions = shuffledQuestions.filter(
      (question) => !selectedQuizQuestions.includes(question)
    );
    if (remainingQuestions.length > 0) {
      selectedQuizQuestions.push(
        remainingQuestions[Math.floor(Math.random() * remainingQuestions.length)]
      );
    } else {
      break;
    }
  }

  // Return exactly 20 questions
  return selectedQuizQuestions.slice(0, QUESTION_NUMBER_PER_CATEGORY);
}

export default generateQuiz;
